module.exports = __webpack_public_path__ + "static/media/cover-1.36c0408a.jpg";